import { IsPhaseAtLeast } from '../workflow/phases.js';
import type { OEPNavItem, OEPUserSnapshot } from './types.js';

/** logic.js:259-265, with the prototype's stages expressed as real phases. */
export function BuildNav(s: OEPUserSnapshot): OEPNavItem[] {
    const nav: OEPNavItem[] = [{ View: 'home', Label: 'Home', Badge: null }];
    if (s.Roles.has('presenter')) nav.push({ View: 'presentation', Label: 'My presentation', Badge: null });
    if (s.Roles.has('reviewer')) {
        const badge = s.Phase === 'Reviewing' && s.Reviewer && s.Reviewer.UnsubmittedReviews > 0 ? s.Reviewer.UnsubmittedReviews : null;
        nav.push({ View: 'reviews', Label: 'Review drafts', Badge: badge });
    }
    if (s.Roles.has('nominator') && IsPhaseAtLeast(s.Phase, 'Nominating')) {
        nav.push({ View: 'nominate', Label: 'Nominate a presenter', Badge: s.Phase === 'Nominating' && s.Nominator ? s.Nominator.PresenterCount : null });
    }
    if (s.Roles.has('committee') && IsPhaseAtLeast(s.Phase, 'Selecting')) {
        const open = s.Phase === 'Selecting' && s.Committee && !s.Committee.SlateSubmitted;
        nav.push({ View: 'committee', Label: 'Select section winners', Badge: open && s.Committee ? s.Committee.NominationCount : null });
    }
    if (s.Roles.has('staff')) {
        nav.push({ View: 'program-status', Label: 'Program status', Badge: null });
        nav.push({ View: 'activity', Label: 'Activity', Badge: null });
        nav.push({ View: 'user-management', Label: 'User management', Badge: null });
    }
    // Client edit 2026-10-27: presenters get no Resources tab until its resources exist.
    if (!s.Roles.has('presenter')) nav.push({ View: 'resources', Label: 'Resources', Badge: null });
    return nav;
}
